const faqSections = document.querySelectorAll('.faq-sec');

faqSections.forEach(section => {
  const accordionItems = section.querySelectorAll('.accordion-item');

  accordionItems.forEach(item => {
    item.addEventListener('click', () => {
      const isActive = item.classList.contains('active');

      // Снять active со всех элементов внутри этой секции
      accordionItems.forEach(i => i.classList.remove('active'));

      if (!isActive) {
        item.classList.add('active');
      }
    });
  });
});
